// extracted by mini-css-extract-plugin
export default {"psevdoBody":"HomePage_psevdoBody__-N32L"};